import _defineProperty from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React, { createContext, useEffect } from 'react';
import isString from "lodash/isString";
import uniq from "lodash/uniq";
import { error } from '@jutro/logger';
import { getConfigValue } from '@jutro/config';
import { getTokenByKey, setToken, removeTokenByKey } from './AuthTokenStorage';
import { OKTA_NOT_FOUND } from './errorcodes/errorcodes';
import { useAuthState } from './AuthStateProvider';
export var AuthContext = createContext();
export var AuthContextProvider = function AuthContextProvider(_ref) {
  var children = _ref.children;

  var _authService$_oktaAut, _authService$_oktaAut3, _authService$_oktaAut4;

  var _useAuthState = useAuthState(),
      authState = _useAuthState.authState,
      authService = _useAuthState.authService;

  var tokenManager = authService === null || authService === void 0 ? void 0 : (_authService$_oktaAut = authService._oktaAuth) === null || _authService$_oktaAut === void 0 ? void 0 : _authService$_oktaAut.tokenManager;
  var basenameUri = getConfigValue('JUTRO_ROUTER_BASENAME', '');
  useEffect(function () {
    var _authService$getAcces, _authService$getIdTok;

    authService === null || authService === void 0 ? void 0 : (_authService$getAcces = authService.getAccessToken) === null || _authService$getAcces === void 0 ? void 0 : _authService$getAcces.call(authService).then(function (result) {
      setToken('accessToken', result);
    });
    authService === null || authService === void 0 ? void 0 : (_authService$getIdTok = authService.getIdToken) === null || _authService$getIdTok === void 0 ? void 0 : _authService$getIdTok.call(authService).then(function (result) {
      setToken('idToken', result);
    });
    subscribeTokenManager();
    return unSubscribeTokenManager;
  }, [authService]);

  var subscribeTokenManager = function subscribeTokenManager() {
    var autoRenew = getConfigValue('JUTRO_AUTH_AUTO_RENEW', true);
    tokenManager === null || tokenManager === void 0 ? void 0 : tokenManager.on('expired', function (key) {
      removeTokenByKey(key);

      if (!autoRenew) {
        logout();
      }
    });
    tokenManager === null || tokenManager === void 0 ? void 0 : tokenManager.on('renewed', function (key, newToken) {
      setToken(key, newToken);
    });
  };

  var unSubscribeTokenManager = function unSubscribeTokenManager() {
    var _tokenManager$off, _tokenManager$off2;

    tokenManager === null || tokenManager === void 0 ? void 0 : (_tokenManager$off = tokenManager.off) === null || _tokenManager$off === void 0 ? void 0 : _tokenManager$off.call(tokenManager, 'expired');
    tokenManager === null || tokenManager === void 0 ? void 0 : (_tokenManager$off2 = tokenManager.off) === null || _tokenManager$off2 === void 0 ? void 0 : _tokenManager$off2.call(tokenManager, 'renewed');
  };

  var allocateToken = function allocateToken(scopes, newTokenKey) {
    var _authService$_oktaAut2, _authService$_config, _newTokens$tokens, errorMsg, _errorMsg, token, defaultScopes, newTokens, accessTokenWrapper;

    return _regeneratorRuntime.async(function allocateToken$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!scopes || scopes.length === 0)) {
              _context.next = 4;
              break;
            }

            errorMsg = "scopes are not provided";
            error(errorMsg);
            return _context.abrupt("return", undefined);

          case 4:
            if (newTokenKey) {
              _context.next = 8;
              break;
            }

            _errorMsg = "newTokenKey is not provided";
            error(_errorMsg);
            return _context.abrupt("return", undefined);

          case 8:
            token = authService === null || authService === void 0 ? void 0 : (_authService$_oktaAut2 = authService._oktaAuth) === null || _authService$_oktaAut2 === void 0 ? void 0 : _authService$_oktaAut2.token;
            defaultScopes = authService === null || authService === void 0 ? void 0 : (_authService$_config = authService._config) === null || _authService$_config === void 0 ? void 0 : _authService$_config.scope;
            scopes = uniq(_concatInstanceProperty(defaultScopes).call(defaultScopes, scopes));
            _context.next = 13;
            return _regeneratorRuntime.awrap(token.getWithoutPrompt({
              scopes: scopes
            }));

          case 13:
            newTokens = _context.sent;
            accessTokenWrapper = newTokens === null || newTokens === void 0 ? void 0 : (_newTokens$tokens = newTokens.tokens) === null || _newTokens$tokens === void 0 ? void 0 : _newTokens$tokens.accessToken;
            setToken(newTokenKey, accessTokenWrapper === null || accessTokenWrapper === void 0 ? void 0 : accessTokenWrapper.accessToken);
            tokenManager.add(newTokenKey, accessTokenWrapper);
            return _context.abrupt("return", getTokenByKey(newTokenKey));

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, null, null, null, Promise);
  };

  var login = function login(fromUri) {
    var additionalParams,
        loginRedirectFallBack,
        loginUri,
        idp,
        params,
        _args2 = arguments;
    return _regeneratorRuntime.async(function login$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            additionalParams = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            loginRedirectFallBack = "".concat(window.location.pathname).concat(window.location.search).replace(basenameUri, '');
            loginUri = isString(fromUri) ? fromUri : getConfigValue('JUTRO_AUTH_LOGIN_REDIRECT_PATH', loginRedirectFallBack);

            if (_includesInstanceProperty(loginUri).call(loginUri, '/logout')) {
              loginUri = '/';
            }

            idp = getConfigValue('JUTRO_AUTH_IDP');
            params = _objectSpread({}, idp ? {
              idp: idp
            } : idp, {}, additionalParams);
            _context2.next = 8;
            return _regeneratorRuntime.awrap(authService.login("".concat(basenameUri).concat(loginUri), params));

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, null, null, null, Promise);
  };

  var logout = function logout(fromUri) {
    var logoutUri;
    return _regeneratorRuntime.async(function logout$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            logoutUri = isString(fromUri) ? fromUri : getConfigValue('JUTRO_AUTH_LOGOUT_REDIRECT_PATH', '/logout');
            return _context3.abrupt("return", authService.logout("".concat(basenameUri).concat(logoutUri)).catch(function (err) {
              var errorCode = err.errorCode;
              var errorMsg = "Jutro Auth logout failure: ".concat(errorCode);
              error(errorMsg);

              if (errorCode !== OKTA_NOT_FOUND) {
                throw new Error(errorMsg);
              }
            }));

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, null, null, null, Promise);
  };

  var getAccessToken = function getAccessToken() {
    return authService.getAccessToken();
  };

  var getIdToken = function getIdToken() {
    return authService.getIdToken();
  };

  var returnNull = function returnNull() {
    return null;
  };

  var decodeFunction = (authService === null || authService === void 0 ? void 0 : (_authService$_oktaAut3 = authService._oktaAuth) === null || _authService$_oktaAut3 === void 0 ? void 0 : (_authService$_oktaAut4 = _authService$_oktaAut3.token) === null || _authService$_oktaAut4 === void 0 ? void 0 : _authService$_oktaAut4.decode) || returnNull;

  var decodeToken = function decodeToken(token) {
    var decoder = decodeFunction;
    return decoder(token);
  };

  var getDecodedIdToken = function getDecodedIdToken() {
    var token;
    return _regeneratorRuntime.async(function getDecodedIdToken$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _regeneratorRuntime.awrap(getIdToken());

          case 2:
            token = _context4.sent;
            return _context4.abrupt("return", decodeToken(token));

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, null, null, null, Promise);
  };

  var getDecodedAccessToken = function getDecodedAccessToken() {
    var token;
    return _regeneratorRuntime.async(function getDecodedAccessToken$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _regeneratorRuntime.awrap(getAccessToken());

          case 2:
            token = _context5.sent;
            return _context5.abrupt("return", decodeToken(token));

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, null, null, null, Promise);
  };

  var getAuth = function getAuth() {
    return _objectSpread({}, authState, {
      authenticated: authState.isAuthenticated,
      tokenManager: tokenManager,
      allocateToken: allocateToken,
      decodeToken: decodeToken,
      getAccessToken: getAccessToken,
      getDecodedIdToken: getDecodedIdToken,
      getDecodedAccessToken: getDecodedAccessToken,
      getIdToken: getIdToken,
      login: login,
      logout: logout
    });
  };

  return React.createElement(AuthContext.Provider, {
    value: getAuth()
  }, children);
};
AuthContextProvider.displayName = 'AuthContextProvider';
AuthContextProvider.__docgenInfo = {
  componentName: "AuthContextProvider",
  packageName: "@jutro/auth",
  description: "AuthContextProvider",
  displayName: "AuthContextProvider",
  methods: [],
  actualName: "AuthContextProvider"
};